import { ApolloClient, InMemoryCache } from '@apollo/client';

export const client = new ApolloClient({
    uri: window.location.hostname === 'localhost'
        ? 'https://api.ndlovu.xyz/query'
        : `https://api.${window.location.hostname}/query`,
    cache: new InMemoryCache()
});
